import {
  LOADED_ANNOUNCEMENT,
} from '../actions'

const initialState = {
  announcement: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADED_ANNOUNCEMENT:
      return {
        ...state,
        announcement: action.announcement,
      }
    default:
      return state
  }
}

export default reducer